import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { Grid } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import { Continue } from 'src/components/AuthLayout/components/Continue/Continue';
import FirstGridItem from 'src/components/FirstGridItem';
import { EmailInputFilled, PasswordInputFilled } from 'src/components/inputs';
import { DataTestIds } from 'src/config/dataTestIds';
import * as S from './LoginForm.styles';
import useLoginValidation from './LoginForm.validation';
const LoginForm = ({
  onSubmit,
  isLoading,
  appendToForm
}) => {
  const {
    t
  } = useTranslation();
  const validation = useLoginValidation();
  const [autoFilled, setAutoFilled] = useState({
    email: false,
    password: false
  });
  const {
    query
  } = useRouter();
  const email = query?.email || '';
  const {
    control,
    handleSubmit,
    formState: {
      errors,
      isValid,
      touchedFields
    }
  } = useForm({
    defaultValues: email ? {
      email
    } : undefined,
    resolver: yupResolver(validation),
    mode: 'onChange'
  });
  const handleAutoFill = field => {
    setAutoFilled(prev => ({
      ...prev,
      [field.name]: true
    }));
  };
  const handleChange = (e, field) => {
    setAutoFilled({
      ...autoFilled,
      [field.name]: false
    });
    field.onChange(e);
  };
  return /*#__PURE__*/React.createElement(S.Form, {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(FirstGridItem, null, /*#__PURE__*/React.createElement(Controller, {
    name: "email",
    control: control,
    defaultValue: "",
    render: ({
      field
    }) => /*#__PURE__*/React.createElement(EmailInputFilled, {
      autoFocus: true,
      name: field.name,
      onAutoFill: () => handleAutoFill(field),
      onChange: e => handleChange(e, field),
      onBlur: field.onBlur,
      value: field.value,
      autoComplete: email ? 'off' : undefined,
      dataTestId: DataTestIds.RegistrationEmail,
      inputError: touchedFields.email && errors.email,
      label: t('b2c.login_form.emailLabel'),
      required: true
    })
  })), /*#__PURE__*/React.createElement(S.GridItem, null, /*#__PURE__*/React.createElement(Controller, {
    name: "password",
    control: control,
    defaultValue: "",
    render: ({
      field
    }) => /*#__PURE__*/React.createElement(PasswordInputFilled, {
      name: field.name,
      onAutoFill: () => handleAutoFill(field),
      onChange: e => handleChange(e, field),
      onBlur: field.onBlur,
      value: field.value,
      dataTestId: DataTestIds.RegistrationPassword,
      inputError: touchedFields.password && errors.password,
      label: t('b2c.login_form.passwordLabel'),
      required: true
    })
  })), appendToForm && /*#__PURE__*/React.createElement(S.LastGridItem, null, appendToForm)), /*#__PURE__*/React.createElement(Continue, {
    "data-testid": DataTestIds.SubmitButton,
    onClick: () => setAutoFilled({
      email: false,
      password: false
    }),
    disabled: Object.values(autoFilled).some(el => !el) && (!isValid || isLoading)
  }, t('b2c.login_form.submit')));
};
export default LoginForm;